export const CREATE = "CREATE";
export const UPDATE = "UPDATE";
export const LIKE = "LIKE";
export const DELETE = "DELETE";
export const FETCH_POST = "FETCH_POST";
export const FETCH_ALL = "FETCH_ALL";
export const FETCH_BY_SEARCH = "FETCH_BY_SEARCH";
export const COMMENT = "COMMENT";

export const START_LOADING = "START_LOADING";
export const STOP_LOADING = "STOP_LOADING";

export const AUTH = "AUTH";
export const LOGOUT = "LOGOUT";

export const RESET_POST_STATE = "RESET_POST_STATE";
